import { DemandDefinitionDetailsFields } from './DemandDefinitionDetailsFields';

export const GeneralStep = () => <DemandDefinitionDetailsFields />;
